(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/system.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/system.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.Systems = Backbone.Model.extend({
    defaults: {
      rsystem: [
        {
          type: 'R',
          full: 0,
          half: 7,
          rows: 16,
          guaranty: 12,
          mg: 1,
          systemNum: 33
        },
        {
          type: 'R',
          full: 0,
          half: 11,
          rows: 16,
          guaranty: 10,
          mg: 1,
          systemNum: 34
        },
        {
          type: 'R',
          full: 2,
          half: 5,
          rows: 12,
          guaranty: 11,
          mg: 1,
          systemNum: 35
        },
        {
          type: 'R',
          full: 3,
          half: 3,
          rows: 24,
          guaranty: 12,
          mg: 1,
          systemNum: 36
        },
        {
          type: 'R',
          full: 4,
          half: 0,
          rows: 9,
          guaranty: 12,
          mg: 1,
          systemNum: 37
        },
        {
          type: 'R',
          full: 4,
          half: 4,
          rows: 24,
          guaranty: 11,
          mg: 1,
          systemNum: 38
        },
        {
          type: 'R',
          full: 4,
          half: 4,
          rows: 144,
          guaranty: 12,
          mg: 1,
          systemNum: 39
        },
        {
          type: 'R',
          full: 4,
          half: 5,
          rows: 48,
          guaranty: 11,
          mg: 1,
          systemNum: 40
        },
        {
          type: 'R',
          full: 4,
          half: 6,
          rows: 24,
          guaranty: 10,
          mg: 1,
          systemNum: 41
        },
        {
          type: 'R',
          full: 4,
          half: 6,
          rows: 72,
          guaranty: 11,
          mg: 1,
          systemNum: 42
        },
        {
          type: 'R',
          full: 4,
          half: 7,
          rows: 48,
          guaranty: 10,
          mg: 1,
          systemNum: 43
        },
        {
          type: 'R',
          full: 4,
          half: 7,
          rows: 144,
          guaranty: 11,
          mg: 1,
          systemNum: 44
        },
        {
          type: 'R',
          full: 5,
          half: 0,
          rows: 18,
          guaranty: 11,
          mg: 1,
          systemNum: 45
        },
        {
          type: 'R',
          full: 5,
          half: 3,
          rows: 36,
          guaranty: 11,
          mg: 1,
          systemNum: 46
        },
        {
          type: 'R',
          full: 5,
          half: 5,
          rows: 108,
          guaranty: 11,
          mg: 1,
          systemNum: 47
        },
        {
          type: 'R',
          full: 6,
          half: 3,
          rows: 24,
          guaranty: 10,
          mg: 1,
          systemNum: 48
        },
        {
          type: 'R',
          full: 6,
          half: 3,
          rows: 72,
          guaranty: 11,
          mg: 1,
          systemNum: 49
        },
        {
          type: 'R',
          full: 6,
          half: 4,
          rows: 44,
          guaranty: 10,
          mg: 1,
          systemNum: 50
        },
        {
          type: 'R',
          full: 7,
          half: 0,
          rows: 36,
          guaranty: 11,
          mg: 1,
          systemNum: 28
        },
        {
          type: 'R',
          full: 7,
          half: 2,
          rows: 34,
          guaranty: 10,
          mg: 1,
          systemNum: 51
        },
        {
          type: 'R',
          full: 7,
          half: 2,
          rows: 108,
          guaranty: 11,
          mg: 1,
          systemNum: 52
        },
        {
          type: 'R',
          full: 8,
          half: 0,
          rows: 27,
          guaranty: 10,
          mg: 1,
          systemNum: 53
        },
        {
          type: 'R',
          full: 8,
          half: 0,
          rows: 81,
          guaranty: 11,
          mg: 1,
          systemNum: 29
        },
        {
          type: 'R',
          full: 8,
          half: 2,
          rows: 324,
          guaranty: 11,
          mg: 1,
          systemNum: 54
        },
        {
          type: 'R',
          full: 9,
          half: 0,
          rows: 222,
          guaranty: 11,
          mg: 1,
          systemNum: 30
        },
        {
          type: 'R',
          full: 9,
          half: 0,
          rows: 243,
          guaranty: 11,
          mg: 1,
          systemNum: 56
        },
        {
          type: 'R',
          full: 10,
          half: 0,
          rows: 153,
          guaranty: 10,
          mg: 1,
          systemNum: 58,
          isLong: true
        },
        {
          type: 'R',
          full: 10,
          half: 0,
          rows: 567,
          guaranty: 11,
          mg: 1,
          systemNum: 31,
          isLong: true
        },
        {
          type: 'R',
          full: 11,
          half: 0,
          rows: 729,
          guaranty: 11,
          mg: 1,
          systemNum: 32,
          isLong: true
        }
      ],
      usystem: [
        {
          type: 'U',
          full: 0,
          half: 7,
          rows: 10,
          guaranty: null,
          mg: 1,
          systemNum: 59,
          uSigns: 7
        },
        {
          type: 'U',
          full: 0,
          half: 10,
          rows: 38,
          guaranty: null,
          mg: 1,
          systemNum: 60,
          uSigns: 10
        },
        {
          type: 'U',
          full: 0,
          half: 11,
          rows: 65,
          guaranty: null,
          mg: 1,
          systemNum: 61,
          uSigns: 11
        },
        {
          type: 'U',
          full: 3,
          half: 6,
          rows: 20,
          guaranty: null,
          mg: 1,
          systemNum: 62,
          uSigns: 9
        },
        {
          type: 'U',
          full: 3,
          half: 6,
          rows: 50,
          guaranty: null,
          mg: 1,
          systemNum: 63,
          uSigns: 9
        },
        {
          type: 'U',
          full: 3,
          half: 7,
          rows: 98,
          guaranty: null,
          mg: 1,
          systemNum: 64,
          uSigns: 10
        },
        {
          type: 'U',
          full: 4,
          half: 3,
          rows: 66,
          guaranty: null,
          mg: 1,
          systemNum: 65,
          uSigns: 7
        },
        {
          type: 'U',
          full: 4,
          half: 4,
          rows: 16,
          guaranty: null,
          mg: 1,
          systemNum: 66,
          uSigns: 8
        },
        {
          type: 'U',
          full: 4,
          half: 4,
          rows: 44,
          guaranty: null,
          mg: 1,
          systemNum: 67,
          uSigns: 8
        },
        {
          type: 'U',
          full: 4,
          half: 5,
          rows: 30,
          guaranty: null,
          mg: 1,
          systemNum: 68,
          uSigns: 9
        },
        {
          type: 'U',
          full: 4,
          half: 5,
          rows: 68,
          guaranty: null,
          mg: 1,
          systemNum: 69,
          uSigns: 9
        },
        {
          type: 'U',
          full: 4,
          half: 7,
          rows: 200,
          guaranty: null,
          mg: 1,
          systemNum: 70,
          uSigns: 11
        },
        {
          type: 'U',
          full: 5,
          half: 5,
          rows: 44,
          guaranty: null,
          mg: 1,
          systemNum: 71,
          uSigns: 10
        },
        {
          type: 'U',
          full: 5,
          half: 5,
          rows: 176,
          guaranty: null,
          mg: 1,
          systemNum: 72,
          uSigns: 10
        },
        {
          type: 'U',
          full: 5,
          half: 6,
          rows: 274,
          guaranty: null,
          mg: 1,
          systemNum: 73,
          uSigns: 11
        },
        {
          type: 'U',
          full: 6,
          half: 3,
          rows: 36,
          guaranty: null,
          mg: 1,
          systemNum: 74,
          uSigns: 9
        },
        {
          type: 'U',
          full: 6,
          half: 4,
          rows: 66,
          guaranty: null,
          mg: 1,
          systemNum: 75,
          uSigns: 10
        },
        {
          type: 'U',
          full: 6,
          half: 4,
          rows: 224,
          guaranty: null,
          mg: 1,
          systemNum: 76,
          uSigns: 10
        },
        {
          type: 'U',
          full: 7,
          half: 3,
          rows: 100,
          guaranty: null,
          mg: 1,
          systemNum: 77,
          uSigns: 10
        },
        {
          type: 'U',
          full: 7,
          half: 4,
          rows: 464,
          guaranty: null,
          mg: 1,
          systemNum: 78,
          uSigns: 11
        },
        {
          type: 'U',
          full: 8,
          half: 2,
          rows: 253,
          guaranty: null,
          mg: 1,
          systemNum: 79,
          uSigns: 10
        },
        {
          type: 'U',
          full: 8,
          half: 3,
          rows: 598,
          guaranty: null,
          mg: 1,
          systemNum: 81,
          uSigns: 11
        },
        {
          type: 'U',
          full: 9,
          half: 2,
          rows: 202,
          guaranty: null,
          mg: 1,
          systemNum: 82,
          uSigns: 11
        },
        {
          type: 'U',
          full: 11,
          half: 0,
          rows: 133,
          guaranty: null,
          mg: 1,
          systemNum: 83,
          uSigns: 11
        },
        {
          type: 'U',
          full: 13,
          half: 0,
          rows: 105,
          guaranty: null,
          mg: 1,
          systemNum: 84,
          uSigns: 13
        }
      ],
      currentSystem: null
    },

    initialize: function() {
      this.listenTo(
        svs.tipset.models.play,
        'changeSingleRows',
        this.toggleSingleRow
      );
    },

    toggleSingleRow: function() {
      if (svs.tipset.models.play.get('isSingleRow')) {
        this.reset();
      } else {
        this.setDataFromLocalStorage();
      }
    },

    setDataFromLocalStorage: function() {
      var systemObj;
      if (
        svs.tipset.models.competition &&
        svs.tipset.models.competition.getCompetitionMode() &&
        svs.tipset.models.competition.getCompetitionSystem()
      ) {
        this.setCurrentSystem(
          svs.tipset.models.competition.getCompetitionSystem()
        );
      } else {
        if (
          svs.tipset.objects.localstorageHandler &&
          svs.tipset.objects.localstorageHandler.dataFromLocalStorage &&
          svs.tipset.objects.localstorageHandler.dataFromLocalStorage.system
        ) {
          systemObj =
            svs.tipset.objects.localstorageHandler.dataFromLocalStorage.system;
          this.setSystemBySystemNum(
            this.getSystemType(systemObj.type),
            systemObj.systemNum
          );
        }
      }
    },

    setSystemBySystemNum: function(systemType, systemNum) {
      if (systemType !== undefined) {
        this.set('showActionbar', true, { silent: true });
      }
      if (
        systemNum &&
        systemType == svs.tipset.constants.SYSTEM_TYPE.R_SYSTEM
      ) {
        this.setCurrentSystem(
          _.findWhere(this.get('rsystem'), { systemNum: systemNum })
        );
      } else if (
        systemNum &&
        systemType == svs.tipset.constants.SYSTEM_TYPE.U_SYSTEM
      ) {
        this.setCurrentSystem(
          _.findWhere(this.get('usystem'), { systemNum: systemNum })
        );
      }
    },

    updateCurrentRSystem: function() {
      this.set('showActionbar', false, { silent: true });
      this.set(
        'currentSystem',
        svs.tipset.models.xpertenSystems.getCurrentSystem()
      );
    },

    createHbsAttributes: function(system, currentSystem) {
      var compiledArray = [];
      this.get(system).forEach(function(obj) {
        var tmpObj = _.clone(obj);
        tmpObj.json = JSON.stringify(tmpObj);
        tmpObj.buttonId =
          obj.type + '-' + obj.full + '-' + obj.half + '-' + obj.rows;
        if (currentSystem && currentSystem.systemNum === obj.systemNum) {
          tmpObj.checked = true;
        }
        compiledArray.push(tmpObj);
      });
      return compiledArray;
    },
    getRsystem: function(currentRsystem) {
      return this.createHbsAttributes('rsystem', currentRsystem);
    },
    getUsystem: function(currentUsystem) {
      return this.createHbsAttributes('usystem', currentUsystem);
    },
    getSpecificSystem: function(systemNum) {
      var system;
      system = _.findWhere(this.get('rsystem'), { systemNum: systemNum });
      if (!system) {
        system = _.findWhere(this.get('usystem'), { systemNum: systemNum });
      }
      return system;
    },

    setCurrentSystem: function(system) {
      if (system !== null && system !== 'reduce-free') {
        this.set('showActionbar', true, { silent: true });
      }
      if (system && system.type == 'R') {
        this.listenTo(
          svs.tipset.models.xpertenSystems,
          'sync',
          this.updateCurrentRSystem
        );
      } else {
        this.stopListening(
          svs.tipset.models.xpertenSystems,
          'sync',
          this.updateCurrentRSystem
        );
      }
      this.set('currentSystem', system);
      this.save();
    },

    getCurrentSystem: function() {
      if (svs.tipset.models.play.get('isReduceMode')) {
        return 'reduce-free';
      }

      return this.get('currentSystem');
    },

    isValidSystem: function() {
      var currentSystem = this.getCurrentSystem(),
        nrOfFullHedges = svs.tipset.collections.matchlist.getNrOfFullHedges(),
        nrOfHalfHedges = svs.tipset.collections.matchlist.getNrOfHalfHedges(),
        nrOfRows = svs.tipset.collections.matchlist.getNrOfRows(),
        isUSystem =
          currentSystem &&
          currentSystem.type == svs.tipset.constants.SYSTEM_TYPE.U_SYSTEM,
        isValidUsystem = isUSystem ? this.isValidUSystem(currentSystem) : true,
        isValid = true;

      if (currentSystem && currentSystem !== 'reduce-free') {
        isValid =
          nrOfHalfHedges == currentSystem.half &&
          nrOfFullHedges == currentSystem.full &&
          nrOfRows <= svs.tipset.models.gameDefinitions.get('maxSystemSize') &&
          isValidUsystem;
      }

      return isValid;
    },

    isValidUSystem: function(system) {
      var isValidUsystem = false;

      if (svs.tipset.collections.matchlist.getNrOfUMarks() == system.uSigns) {
        isValidUsystem = true;
      }

      return isValidUsystem;
    },

    clear: function() {
      this.set('showActionbar', false, { silent: true });
      this.set('currentSystem', null, { silent: true });
      this.stopListening(
        svs.tipset.models.xpertenSystems,
        'sync generateSystem',
        this.updateCurrentRSystem
      );
      this.save();
      this.trigger('change systemCleared', this);
    },

    getSystemName: function() {
      var system = this.getCurrentSystem();
      if (!!system && system !== 'reduce-free') {
        return (
          system.type +
          ' ' +
          system.full +
          '-' +
          system.half +
          '-' +
          system.rows
        );
      }
      return '';
    },

    save: function() {
      svs.tipset.objects.localstorageHandler.saveDataToLocalStorage();
    },

    reset: function() {
      this.set('currentSystem', null, { silent: true });
      this.stopListening(
        svs.tipset.models.xpertenSystems,
        'sync generateSystem',
        this.updateCurrentRSystem
      );
      this.trigger('change systemCleared', this);
    },

    getSystemType: function(systemTypeToConvert) {
      var systemTypes = svs.tipset.constants.ITS_SYSTEM.SYSTEM_TYPES,
        systemObj = _.findWhere(systemTypes, {
          itsSystemType: systemTypeToConvert
        }),
        systemType = systemObj ? systemObj.systemType : systemTypeToConvert;
      return systemType;
    }
  });
})(Backbone, _, svs);

 })(window);